module.exports = __webpack_public_path__ + "static/img/advantage-quality-bg.dd54d66f.png";